import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import { useAssets } from "../assets/AssetsContext";
import ClientLogoSlider from "./ClientLogoSlider";

function Home() {
  const assets = useAssets();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    AOS.refresh();
  }, []);
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div>
      <div className="section-1">
        <div className="relative-1">
          <div className="s1-heading-text">
            <h1 data-aos="zoom-in">Engineering Earth’s Comeback</h1>
            <p data-aos="zoom-in">
              Welcome to Accel1 — World’s First Climate Engineering Super
              Platform for Regenerative Industry, Carbon Removal, and
              Planetary-scale Solutions.
            </p>
            <Link to="/company/about" className="button-1 green-bg">
              Explore Our Mission
            </Link>
            <Link to="/company/contact" className="button-1">
              Partner With Us
            </Link>
          </div>
          {/* <img src={assets.banner1} alt="" data-aos="fade-in" /> */}

          <video
            className="banner-video"
            src={assets.bannervideo} // Put your video in public/videos folder
            autoPlay
            muted
            loop
            playsInline
          />
        </div>
      </div>

      <div className="section-2">
        <div className="wrapper height-inherit">
          <div className="section-2-1">
            <h2 data-aos="zoom-in">What is Climate Engineering?</h2>
            <p data-aos="fade-down">
              Climate engineering is the next frontier in reversing planetary
              damage — combining science, systems, and scale to go beyond net
              zero and build a climate-positive future. Discover how
              breakthrough innovations are reshaping Earth’s systems for
              resilience and regeneration.
            </p>
            <p>
              <b>
                <i>Beyond Net Zero. Toward Climate Positivity.</i>
              </b>
            </p>
          </div>
          <div className="section-2-2">
            <h6 className="w-100">Key domains:</h6>
            <div className="section-2-2-1" data-aos="zoom-in-down">
              <img src={assets.CarbonRemoval} alt="" />
              <span>
                Carbon
                <br />
                Removal
              </span>
            </div>
            <div className="section-2-2-1" data-aos="zoom-in-down">
              <img src={assets.BiocharSoilEnhancement} alt="" />
              <span>
                Biochar & Soil
                <br />
                Enhancement
              </span>
            </div>
            <div className="section-2-2-1" data-aos="zoom-in-down">
              <img src={assets.WaterIntelligence} alt="" />
              <span>
                Water
                <br />
                Intelligence
              </span>
            </div>
            <div className="section-2-2-1" data-aos="zoom-in-down">
              <img src={assets.CircularManufacturing} alt="" />
              <span>
                Circular
                <br />
                Manufacturing
              </span>
            </div>
            <div className="section-2-2-1" data-aos="zoom-in-down">
              <img src={assets.AtmosphereAirQualityEngineerin} alt="" />
              <span>
                Atmosphere & Air
                <br />
                Quality Engineering
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="section-3">
        <div className="wrapper height-inherit">
          <div className="section-2-1">
            <h2>Climate Solutions, Built to Scale</h2>
            <p>
              Explore our suite of engineered platforms designed to accelerate
              climate action across air, water, soil, and supply chains.
            </p>
          </div>

          <div className="section-3-2">
            <div className="section-3-2-1" data-aos="zoom-in-up">
              <div className="section-3-2-img">
                <img src={assets.HydroTRACELogo} alt="" />
              </div>
              <span>Water Intelligence Platform</span>
            </div>
            <div className="section-3-2-1" data-aos="fade-up">
              <div className="section-3-2-img">
                <img src={assets.BioForgeLogo} alt="" />
              </div>
              <span>Modular Biochar Units</span>
            </div>

            <div className="section-3-2-1" data-aos="zoom-in-down">
              <div className="section-3-2-img">
                <img src={assets.AtmosPODLogo} alt="" />
              </div>
              <span>Planetary Air Monitoring & Sequestration</span>
            </div>
            <div className="section-3-2-1" data-aos="zoom-in-down">
              <div className="section-3-2-img">
                <img src={assets.AccelTRACKLogo} alt="" />
              </div>
              <span>ESG & Carbon Data Backbone</span>
            </div>

            <div className="section-3-2-1" data-aos="zoom-in-up">
              <div className="section-3-2-img">
                <img src={assets.AccelALERTLogo} alt="" />
              </div>
              <span>HSE and Disaster Readiness</span>
            </div>

            <div className="section-3-2-1" data-aos="fade-down">
              <div className="section-3-2-img">
                <img src={assets.AccelSupplyLogo} alt="" />
              </div>
              <span>Sustainable Supply Chain Platform</span>
            </div>
          </div>
        </div>
      </div>

      <div className="flagship-bg">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2>Flagship Projects</h2>
            <p>
              From drylands to data platforms, our breakthrough initiatives
              showcase how scalable climate engineering is driving real-world
              transformation.
            </p>
          </div>

          <div className="timeline">
            <div className="timeline-line"></div>

            <div className="timeline-item right">
              <div className="timeline-icon"></div>
              <div className="timeline-content">
                <img
                  src={assets.accel1innovation}
                  alt=""
                  data-aos="zoom-out-down"
                />
                <h3>
                  World’s 1<sup>st</sup> Green Silicon Valley @ Kambalapadu,
                  Andhra Pradesh, India
                </h3>
                <p>
                  <b className="light-green-color padding-l-0">
                    Where Climate Intelligence Meets Rural Innovation
                  </b>
                </p>
                <p>
                  Nestled in the heart of Andhra Pradesh,
                  <b>
                    the Accel1’s World’s 1st Green Silicon Valley @ Kambalapadu
                  </b>
                  spans over <b>200 acres</b>
                  and is more than a facility — it’s a living lab for
                  <b>
                    climate-tech, sustainability, and deep-tech engineering.
                  </b>
                  This expansive campus brings together
                  <b>
                    farmers, scientists, AI technologists, and policy leaders
                  </b>
                  to co-create scalable solutions in
                  <b>
                    water intelligence, regenerative agriculture, biochar
                    systems, and ESG automation.
                  </b>
                </p>
                <p>
                  From piloting <b>drone-enabled cloud seeding</b> to training
                  <b>rural youth in carbon farming and global ESG frameworks</b>
                  , the center serves as a
                  <b>launchpad for planet-first innovation</b> — deeply rooted
                  in local wisdom and boldly driving global impact.
                </p>
              </div>
            </div>

            <div className="timeline-item left">
              <div className="timeline-icon"></div>
              <div className="timeline-content">
                <img
                  src={assets.BiocharSoilEnhancement2}
                  alt=""
                  data-aos="zoom-out-up"
                />
                <h3>Accel1 Innovation Nexus @ Rajasthan</h3>
                <p>
                  <b>
                    Empowering Farmers, Reviving Land, Reimagining Climate
                    Futures
                  </b>
                </p>
                <p>
                  At the crossroads of tradition and technology, Accel1’s
                  Innovation Nexus in Rajasthan is transforming climate
                  challenges into rural opportunities. We're deploying
                  cutting-edge platforms like
                  <b>HydroTRACE™, BioFORGE™, and AccelTRACK™</b> to bring
                  AI-powered rainfall solutions, regenerative agriculture, and
                  carbon credit readiness to tribal and farming communities.
                  From building decentralized biochar micro-enterprises to
                  training thousands of youth in climate enterprise, this
                  initiative is a bold step toward
                  <b>
                    water resilience, green jobs, and sustainable prosperity —
                  </b>
                  placing Rajasthan at the forefront of India’s climate
                  transformation.
                </p>
              </div>
            </div>

            <div className="timeline-item right">
              <div className="timeline-icon"></div>
              <div className="timeline-content">
                <img
                  src={assets.HydroTRACEDeployment}
                  alt=""
                  data-aos="flip-left"
                  data-aos-easing="ease-out-cubic"
                  data-aos-duration="3000"
                />
                <h3>Planet-First Platforms, Engineered for Impact</h3>
                <p>
                  At Accel1, we are pioneering Climate Engineering at Scale —
                  deploying integrated technologies that regenerate ecosystems,
                  empower communities, and future-proof economies. From
                  restoring rain in arid zones with HydroTRACE™, to enriching
                  soil through <b>BioFORGE™,</b> and automating
                  <b>ESG intelligence with AccelTRACK™</b>, we are designing
                  climate solutions that are both local and planetary. Our
                  AtmosPOD system monitors atmospheric health in real time,
                  while AccelSupply connects sustainable businesses to verified
                  farmer networks, and AccelALERT delivers AI-powered early
                  warnings for floods, droughts, and climate shocks. Together,
                  these platforms form a living climate infrastructure —
                  predictive, regenerative, and ready for scale.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ClimateFutureTogether-bg">
        <div className="wrapper">
          <div className="clients-heading">
            <h2>Partners & Collaborators</h2>
          </div>
          <ClientLogoSlider />
        </div>
      </div>
      <div className="vision-impact-bg">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2>Vision & Impact Goals</h2>
            <p>
              Driving bold, measurable outcomes to regenerate the planet,
              empower communities, and scale climate innovation for a resilient
              future.
            </p>
          </div>
          <img
            src={assets.VisionImpactImg}
            alt="VisionImpactImg"
            data-aos="zoom-in"
            className="d-d"
          />
          <img
            src={assets.VisionImpactImgMobile}
            alt="VisionImpact Img Mobile"
            data-aos="zoom-in"
            className="m-d"
          />
        </div>
      </div>

      <div className="ClimateFutureTogether-bg">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2>Ready to Build the Climate Future Together?</h2>
            <p>
              Join the movement reshaping Earth's systems. Whether you want to
              collaborate, contribute, or create, Accel1 offers pathways to take
              action at the frontier of climate engineering.
            </p>

            <Link
              to="/company/contact#Book-Meeting"
              className="button-1"
              onClick={scrollToTop}
            >
              Book a Meeting
            </Link>
            <Link
              to="/company/contact#Book-Meeting"
              className="button-1 "
              onClick={scrollToTop}
            >
              Join Our Ecosystem
            </Link>
            <Link
              to="/company/careers"
              className="button-1"
              onClick={scrollToTop}
            >
              Explore Careers
            </Link>
          </div>
        </div>
      </div>
      {/* <div className="section-1" style={sectionStyle}>
        <img src={assets.banner1} alt="" data-aos="fade-up" />
      </div> */}
    </div>
  );
}

export default Home;
